// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.route-code,\n.el-table th.route-code {\n  width: 6em;\n}\n.el-table .route-code .el-tag {\n  width: 2.5em !important;\n  text-align: center;\n  color: #606266;\n  background-color: #e9e7e7;\n  border-color: #e9e7e7;\n}", ""]);
// Exports
module.exports = exports;
